<template>
  <!-- 搜索页面 -->
  <div class="content">
    <div class="header">
      <van-icon class="arrow-left" name="arrow-left" @click="toback" />
      <div class="search">
        <van-cell-group class="searchSe">
          <van-field
            v-model="value"
            left-icon="search"
            ref="fieldPhone"
            placeholder="请输入搜索关键词"
          />
        </van-cell-group>
      </div>
      <div class="searchs">
        <div @click="onSearch">搜索</div>
      </div>
    </div>
    <div class="center">
      <div class="historySearch">
        <h5>历史搜索</h5>
        <span @click="removeHistorySearchLists"
          ><van-icon name="delete-o"
        /></span>
      </div>
      <ul class="historySearchList">
        <li
          @click="searchHistory(item)"
          v-for="item in historySearchLists"
          :key="item.index"
        >
          <span>{{ item }}</span>
        </li>
      </ul>
      <ul class="searchList">
        <li
          v-for="item in productList"
          :key="item.id"
          @click="getProductInfo(item.goods_id)"
        >
          <div class="img">
            <img :src="item.image_url" alt="" />
          </div>
          <div class="searchText">
            <p class="p1">{{ item.goods_name }}</p>
            <p class="p2" v-html="item.content"></p>
            <span>￥{{ item.outer_goods_price }}</span>
          </div>
        </li>
      </ul>
      <div v-if="imgBoxShow" class="imgBox">
        <img src="../../assets/img/组 9696 .png" alt="" />
        <p>未搜索到相关内容</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      imgBoxShow: false,
      LoadingShow: true,
      value:
        sessionStorage.getItem("SEARCH_VALUE") != ""
          ? sessionStorage.getItem("SEARCH_VALUE")
          : "",
      productList:
        JSON.parse(sessionStorage.getItem("SEARCH_VAL")) != null
          ? JSON.parse(sessionStorage.getItem("SEARCH_VAL"))
          : {},
      //历史搜索
      historySearchList: [],
      historySearchLists: JSON.parse(localStorage.getItem("_histroy")),
    };
  },
  created() {
    if (localStorage._histroy) {
      return false;
    } else {
      localStorage.setItem("_histroy", JSON.stringify(this.historySearchList));
    }
  },
  mounted() {
    // 页面加载完毕  调用键盘事件
    this.$nextTick(() => {
      this.$refs.fieldPhone.focus();
    });
  },
  methods: {
    // 清除历史搜索
    removeHistorySearchLists() {
      localStorage.removeItem("_histroy");
      this.historySearchLists = [];
      this.historySearchList = [];
      //清除历史搜索后重新赋值给本地存储
      if (localStorage._histroy) {
        return false;
      } else {
        localStorage.setItem(
          "_histroy",
          JSON.stringify(this.historySearchList)
        );
      }
    },
    // 点击搜索
    async onSearch() {
      if (this.value == "") {
        this.$toast("请输入关键字");
      } else {
        this.productList = {};
        await this.$post({
          url: "/owsProductInfo/findInfo",
          method: "get",
          params: {
            content: this.value,
          },
        })
          .then((res) => {
            this.historySearchList = this.historySearchList = JSON.parse(
              localStorage.getItem("_histroy")
            );
            if (this.historySearchList.indexOf(this.value) == -1) {
              this.historySearchList.unshift(this.value);
            }
            localStorage.setItem(
              "_histroy",
              JSON.stringify(this.historySearchList)
            );
            if (res.retCode == 200) {
              if (res.data.length >= 1) {
                this.imgBoxShow = false;
                this.productList = res.data;
              } else {
                this.imgBoxShow = true;
                this.$toast("未查询到相关信息");
              }
            } else {
              this.$toast("加载失败");
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    // 跳转到商品详情
    getProductInfo(id) {
      sessionStorage.setItem("SEARCH_VAL", JSON.stringify(this.productList));
      sessionStorage.setItem("SEARCH_VALUE", this.value);
      sessionStorage.setItem("P_ID", id);
      this.$router.push({ path: "/toShopping" });
    },
    //  搜索历史
    searchHistory(item) {
      this.value = item;
      this.onSearch();
    },
    toback() {
      this.$router.back();
      sessionStorage.removeItem("SEARCH_VAL");
      sessionStorage.removeItem("SEARCH_VALUE");
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #f4f4f4;
  .header {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    height: 1.375rem;
    font-size: 0.48rem;
    font-weight: 500;
    z-index: 1;
    overflow: hidden;
    background-color: #fefefe;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.2rem;
    box-sizing: border-box;
    .arrow-left{
      font-size: 0.533333rem;
    }
    .appTitle {
      padding-left: 0.1875rem;
    }
    .search {
      .searchSe {
        height: 1rem;
        border-radius: 0.9375rem;
        overflow: hidden;
        background-color: #f4f4f4;
        /deep/.van-cell {
          background-color: #f4f4f4;
          padding: 0.2rem 0.42667rem;
        }
      }
    }
    .searchs {
      box-sizing: border-box;
      border: 0;
      div {
        font-size: 0.373333rem;
        padding-right: 0.426667rem;
        color: #666666;
      }
    }
  }
  .center {
    padding: 0 0.37rem;
    width: 100%;
    padding-top: 1.375rem;
    box-sizing: border-box;

    .historySearch {
      margin-top: 0.6rem;
      width: 9.2rem;
      height: 1rem;
      line-height: 1rem;
      h5 {
        float: left;
        font-size: 0.43rem;
        color: #333333;
      }
      span {
        float: right;
        i {
          font-size: 0.52rem;
        }
      }
    }
    .historySearchList {
      max-height: 2.48rem;
      overflow: hidden;
      li {
        float: left;
        margin: 0.15rem;
        padding: 0 0.2rem;
        height: 0.72rem;
        line-height: 0.72rem;
        font-size: 0.32rem;
        background: #e0e0e0;
        opacity: 0.7;
        border-radius: 0rem;
        text-align: center;
        border-radius: 0.5rem;
        max-width: 3rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .searchList {
      // margin-top: 0.5rem;
      li {
        width: 9.253333rem;
        padding: 0.2667rem 0;
        // height: 2.666667rem;
        background-color: #ffffff;
        margin: 0.3rem 0;
        border-radius: 0.08rem;
        display: flex;
        align-items: center;
        overflow: hidden;
        .img {
          margin-left: 0.293333rem;
          // width: 2.72rem;
          // overflow: hidden;
          img {
            width: 2.72rem;
            height: auto;
          }
        }
        .searchText {
          margin-left: 0.64rem;
          .p1 {
            font-size: 0.426667rem;
            font-weight: 500;
            color: #333333;
          }
          .p2 {
            font-size: 0.32rem;
            font-weight: 400;
            color: #666666;
            // margin: 0.186667rem 0;
            margin: 0.133333rem 0 0.186667rem 0;
          }
          span {
            font-size: 0.373333rem;
            font-weight: 500;
            color: #f74b2e;
          }
        }
      }
    }
    .imgBox {
      margin-top: 1.5rem;
      img {
        margin: 0 auto;
        width: 7.44rem;
        display: block;
      }
      p {
        text-align: center;
        color: #999999;
      }
    }
  }
  .van-loading {
    z-index: 99;
    position: fixed;
    top: 53%;
    left: 50%;
    transform: translate(-50%);
  }
}
</style>
